import React, { useState } from "react";
import PropTypes from "prop-types";
import PinField from "react-pin-field";
import { useSnackbar } from "notistack";
import Box from "@mui/material/Box";
import GrButton from "src/design-system/components/GrButton";
import { gr } from "src/design-system/tokens";

// Six PIN boxes in the field look (line border, radius 10, brand border + focus ring on focus).
const pinBoxesSx = {
  display: "flex",
  gap: gr.space[2],
  "& input": {
    flex: "1 1 0",
    minWidth: 0,
    maxWidth: gr.control.lg,
    height: gr.control.lg,
    p: 0,
    textAlign: "center",
    caretColor: "transparent",
    fontFamily: gr.font.family,
    fontSize: gr.font.size.xl,
    fontWeight: gr.font.weight.medium,
    color: gr.color.ink,
    background: gr.color.surface,
    border: `1px solid ${gr.color.line}`,
    borderRadius: gr.radius.control,
    outline: "none",
    transition: "border-color .15s ease, box-shadow .15s ease",
  },
  "& input:hover": { borderColor: gr.color.lineStrong },
  "& input:focus": { borderColor: gr.color.brand, boxShadow: gr.shadow.focus },
};

export default function PinCodeForm({
  onhandlePinCodeSubmit,
  setIsLoading,
  isLoading,
}) {
  const { enqueueSnackbar } = useSnackbar();
  const [pinCode, setPinCode] = useState("");

  const handleSubmit = (e) => {
    setIsLoading(true);
    e.preventDefault();
    if (pinCode.length > 5) {
      onhandlePinCodeSubmit(pinCode);
    } else {
      enqueueSnackbar("All fields should be filled", {
        variant: "error",
      });
      setIsLoading(false);
    }
  };

  return (
    <form noValidate onSubmit={handleSubmit}>
      <Box sx={pinBoxesSx}>
        <PinField
          onChange={setPinCode}
          type="numeric"
          inputMode="numeric"
          validate={/^[0-9]$/}
          length={6}
        />
      </Box>
      {/* The button only changes its text while sending (as before), it is not disabled. */}
      <GrButton type="submit" size="lg" fullWidth sx={{ mt: gr.space[6] }}>
        {isLoading ? "Submiting..." : "Submit"}
      </GrButton>
    </form>
  );
}

PinCodeForm.propTypes = {
  onhandlePinCodeSubmit: PropTypes.func.isRequired,
  setIsLoading: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};
